import React, { useState } from "react";
import { Mail, MapPin, Phone, Store } from "lucide-react";
import { api } from "../lib/api";
import { useSettings } from "../lib/SettingsContext";
import { toast } from "sonner";

export default function Contact() {
  const { settings } = useSettings();
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const address = settings.contact_address || "Șoseaua Ghermănești, nr. 50A, Ghermănești, România, 077170";
  const phone = settings.contact_phone || "+40 755 680 215";
  const phoneAlt = settings.contact_phone_alt || "";
  const email = settings.contact_email || "johny.antiqueshop@gmail.com";
  const businessName = settings.contact_business_name || "Johny's Antiques Shop";
  const mapQuery = encodeURIComponent(address);
  const mapEmbed = `https://maps.google.com/maps?q=${mapQuery}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
  const mapLink = `https://www.google.com/maps/search/?api=1&query=${mapQuery}`;

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Mesajul a fost trimis. Te vom contacta în curând.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch { toast.error("Eroare la trimitere"); }
    setLoading(false);
  };

  return (
    <main className="pt-32 pb-20" data-testid="contact-page">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-12">
        <header className="text-center mb-16">
          <p className="label-luxe text-[#D4AF37] mb-3">Discută cu Noi</p>
          <h1 className="h-display text-5xl sm:text-7xl text-[#F8F4E6]">Contact Curatorial</h1>
        </header>
        <div className="grid lg:grid-cols-2 gap-16">
          <div>
            <p className="text-[#A39E8A] leading-relaxed mb-10">
              Suntem la dispoziția ta pentru întrebări private despre achiziții, expertize sau colaborări cu casele de licitație internaționale.
            </p>
            <ul className="space-y-6 text-sm">
              <li className="flex gap-4 items-start" data-testid="contact-business">
                <Store size={18} className="text-[#D4AF37] mt-1 flex-shrink-0" />
                <span>
                  <span className="label-luxe block mb-1">Galerie</span>
                  <span className="text-[#F8F4E6] font-serif text-lg block">{businessName}</span>
                </span>
              </li>
              <li className="flex gap-4 items-start" data-testid="contact-address">
                <MapPin size={18} className="text-[#D4AF37] mt-1 flex-shrink-0" />
                <span>
                  <span className="label-luxe block mb-1">Adresă</span>
                  <a href={mapLink} target="_blank" rel="noreferrer" className="text-[#F8F4E6] hover:text-[#D4AF37] transition">{address}</a>
                </span>
              </li>
              <li className="flex gap-4 items-start" data-testid="contact-phone">
                <Phone size={18} className="text-[#D4AF37] mt-1 flex-shrink-0" />
                <span>
                  <span className="label-luxe block mb-1">Telefon</span>
                  <a href={`tel:${phone.replace(/\s/g,"")}`} className="text-[#F8F4E6] hover:text-[#D4AF37] transition block">{phone}</a>
                  {phoneAlt && <a href={`tel:${phoneAlt.replace(/\s/g,"")}`} className="text-[#A39E8A] hover:text-[#D4AF37] transition text-xs">{phoneAlt}</a>}
                </span>
              </li>
              <li className="flex gap-4 items-start" data-testid="contact-email">
                <Mail size={18} className="text-[#D4AF37] mt-1 flex-shrink-0" />
                <span>
                  <span className="label-luxe block mb-1">Email</span>
                  <a href={`mailto:${email}`} className="text-[#F8F4E6] hover:text-[#D4AF37] transition break-all">{email}</a>
                </span>
              </li>
            </ul>
            <div className="mt-10 aspect-[16/10] overflow-hidden border border-[#D4AF37]/15" data-testid="contact-map">
              <iframe
                title={`Locație ${businessName}`}
                src={mapEmbed}
                className="w-full h-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                style={{ filter: "grayscale(60%) contrast(110%) brightness(85%)" }}
              />
            </div>
          </div>
          <form onSubmit={submit} className="space-y-6" data-testid="contact-form">
            <input className="input-luxe" required placeholder="Numele Tău" value={form.name} onChange={e => setForm({...form, name: e.target.value})} data-testid="contact-name" />
            <input className="input-luxe" type="email" required placeholder="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} data-testid="contact-email-input" />
            <input className="input-luxe" required placeholder="Subiect" value={form.subject} onChange={e => setForm({...form, subject: e.target.value})} data-testid="contact-subject" />
            <textarea className="input-luxe" required placeholder="Mesajul tău..." value={form.message} onChange={e => setForm({...form, message: e.target.value})} data-testid="contact-message" />
            <button disabled={loading} className="btn-gold" data-testid="contact-submit">{loading ? "Se trimite..." : "Trimite Mesaj"}</button>
          </form>
        </div>
      </div>
    </main>
  );
}
